var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Badge, styled, Typography, Box } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
var AppNameWrapper = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
        '& .MuiTypography-appName': {
            paddingBlock: theme.spacing(0.75),
        },
    });
});
var AppName = function (_a) {
    var _b = _a.badgeColor, badgeColor = _b === void 0 ? 'secondary' : _b, badgeContent = _a.badgeContent, badgeProps = _a.badgeProps, logo = _a.logo, name = _a.name, typographyProps = _a.typographyProps, props = __rest(_a, ["badgeColor", "badgeContent", "badgeProps", "logo", "name", "typographyProps"]);
    return (React.createElement(AppNameWrapper, __assign({}, props),
        logo,
        React.createElement(Badge, __assign({ color: badgeColor, badgeContent: badgeContent }, badgeProps),
            React.createElement(Typography, __assign({ variant: "h4", className: clsx('MuiTypography-appName', typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.className) }, typographyProps), name))));
};
export default AppName;
